// Phase 1A Step 34 — Single agent card.
// Extracted from AgentSwarm.tsx for LOC ceiling.

import type { Agent } from "./landing-data.ts";

interface AgentCardProps {
  agent: Agent;
  idx: number;
}

export function AgentCard({ agent, idx }: AgentCardProps): JSX.Element {
  return (
    <div
      style={{
        position: "relative",
        background: "var(--surface)",
        border: "1px solid var(--border)",
        padding: "22px 22px 24px",
        minHeight: 230,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 22,
          height: 22,
          borderTop: "1px solid var(--accent)",
          borderRight: "1px solid var(--accent)",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 18,
        }}
      >
        <span
          className="mono"
          style={{ fontSize: 10, letterSpacing: "0.18em", color: "var(--accent)" }}
        >
          AGENT.{agent.glyph}
        </span>
        <span className="live-dot" style={{ animationDelay: `${idx * 0.3}s` }} />
      </div>
      <div
        className="display"
        style={{
          fontSize: 38,
          color: "var(--text)",
          marginBottom: 4,
          letterSpacing: "0.01em",
        }}
      >
        {agent.name}
      </div>
      <div
        className="mono"
        style={{
          fontSize: 10,
          letterSpacing: "0.16em",
          color: "var(--accent-dim)",
          textTransform: "uppercase",
          marginBottom: 16,
        }}
      >
        {agent.role}
      </div>
      <div
        style={{
          fontSize: 13,
          color: "var(--text-muted)",
          lineHeight: 1.55,
          marginTop: "auto",
        }}
      >
        {agent.desc}
      </div>
    </div>
  );
}
